<div class="container">
    <div multilang class="pop-title">Beliebte Filter</div>
    <div class="bubbles" [class.scroll]="scroll">
        @for(bub of popularFilters;track $index){
        <button multilang (click)="select(bub)" class="bubble" [class.scroll-bubble]="scroll"
            [class.selected]="selectedFilters.value.includes(bub.code)">{{bub.name}}</button>
        }
    </div>
</div>